import { showApiError } from "@/utils";

export const fetchRetrievalScores = (
  queries,
  webpageContent,
  BACKEND_URL,
  handleResponse,
) => {
  return fetch(`${BACKEND_URL}/api/v1/retrieval-score/get-batch-scores`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      queries: queries,
      webpage_content: webpageContent,
    }),
  })
    .then(handleResponse)
    .then((resp) => {
      return resp;
    })
    .catch((err) => {
      console.error("Error fetching retrieval scores:", err);
      showApiError("Failed to fetch retrieval scores. Please try again.");
    });
};
